import React from 'react'
import { keyBy } from 'lodash'
import PropTypes from 'prop-types'
import Text from 'cms/CmsText'

const getPercentDiscount = (price, discount) => {
  const calculateDiscount = (o, d) => Math.floor((d / o) * 100) * -1

  if (price.max > discount.max) {
    return calculateDiscount(price.max, discount.max)
  } else if (price.min > discount.min) {
    return calculateDiscount(price.min, discount.min)
  }
  return undefined
}

const Badge = ({ product }) => {
  if (product) {
    if (product.properties) {
      const badge = keyBy(product.properties, 'code').badge
      if (badge) {
        return (
          <div className="product-badge">
            <Text size="medium" bold>
              {badge.value[0]}
            </Text>
          </div>
        )
      }
    }
    if (product.price && product.price.discount) {
      const percentDiscount = getPercentDiscount(product.price.original, product.price.discount)
      return percentDiscount && (
        <div className="product-badge">
          <Text size="medium" bold>
            {`${percentDiscount}%`}
          </Text>
        </div>
      )
    }
  }
  return null
}

Badge.propTypes = {
  product: PropTypes.object.isRequired,
}
Badge.defaultProps = {}

export default Badge



// WEBPACK FOOTER //
// ./src/cms/components/productCard/Badge.js